var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["emd-alert", _vm.enumVariant[_vm.variant]] }, [
    _c("div", { staticClass: "emd-alert__icon" }, [
      _c("i", { class: ["uil", "uil-" + _vm.enumIcon[_vm.variant]] }),
    ]),
    _c(
      "div",
      { staticClass: "emd-alert__content" },
      [
        _vm.title
          ? _c("h1", { staticClass: "emd-alert__title" }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ])
          : _vm._e(),
        _vm._t("content"),
      ],
      2
    ),
    _c(
      "a",
      {
        staticClass: "emd-alert__close",
        attrs: { href: "javascript:void(0)" },
        on: {
          click: function ($event) {
            return _vm.$emit("cancel")
          },
        },
      },
      [
        _vm.autoclose
          ? _c(
              "svg",
              {
                attrs: {
                  width: "24px",
                  height: "24px",
                  viewBox: "0 0 30 30",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "close-with-timer",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        id: "timer",
                        stroke: "#000000",
                        "stroke-width": "3",
                        cx: "15",
                        cy: "15",
                        r: "13",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M17.2745455,15 L20.6860227,11.5885227 C21.1046591,11.1698864 21.1046591,10.4911364 20.6860227,10.0721591 L19.9278409,9.31397727 C19.5092045,8.89534091 18.8304545,8.89534091 18.4114773,9.31397727 L15,12.7254545 L11.5885227,9.31397727 C11.1698864,8.89534091 10.4911364,8.89534091 10.0721591,9.31397727 L9.31397727,10.0721591 C8.89534091,10.4907955 8.89534091,11.1695455 9.31397727,11.5885227 L12.7254545,15 L9.31397727,18.4114773 C8.89534091,18.8301136 8.89534091,19.5088636 9.31397727,19.9278409 L10.0721591,20.6860227 C10.4907955,21.1046591 11.1698864,21.1046591 11.5885227,20.6860227 L15,17.2745455 L18.4114773,20.6860227 C18.8301136,21.1046591 19.5092045,21.1046591 19.9278409,20.6860227 L20.6860227,19.9278409 C21.1046591,19.5092045 21.1046591,18.8304545 20.6860227,18.4114773 L17.2745455,15 Z",
                        id: "xis",
                        fill: "#000000",
                        "fill-rule": "nonzero",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _c("i", { staticClass: "uil uil-times" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }